import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { TableContainer } from '../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';
import { InstanceDetailsContainer, ActivityLogsTableContainer } from '../../Styles/InstanceManagement/instanceManagementStyles';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';
import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';
import DateHelper from '../../Utilities/Helpers/DateHelper';

import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { OrderByEnum } from '../../Utilities/Enums/SortEnums';
import { InstanceActivityLogsListField } from '../../Utilities/Enums/ParametersEnum';
import { InstanceQueryTypeEnum } from '../../Utilities/Enums/StatusEnums';

import CustomListComponent from '../../CustomViews/Pages/ListComponent/CustomListComponent';

import { InstanceActivityLogInterface, InstanceActivityLogsList } from '../../Models/InstanceManagement/InstanceManagement';

import { useInstanceManagementHook } from '../../Hooks/InstanceManagement/instanceManagementHooks';

export default function InstanceActivityLogs(props: InstanceActivityLogInterface) {
    let { triggeredQuery, settriggeredQuery } = props;
    let location = useLocation();
    let queryParams = new URLSearchParams(location.search);
    let instanceId = queryParams.get('id') ?? "0";
    let isDarkMode = LocalStorageHelper.isDarkMode();

    // states
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
        status: QueryBuilderHelper.DefaultQueryFilterValue('status') ?? 0,
        sortBy: QueryBuilderHelper.DefaultSortValue(InstanceActivityLogsListField.CREATED_DATE),
        orderBy: QueryBuilderHelper.DefaultOrderValue(OrderByEnum.DESC),
    });

    const q_queryKey = [CachingEnum.INSTANCE_ACTIVITY_LOGS_LIST, queryStr]
    const { data, fetchStatus, instancesInvalidateQueries } = useInstanceManagementHook(q_queryKey, queryStr, true, InstanceQueryTypeEnum.ACTIVITY_LOGS, instanceId);
    
    const tableColumns = [
        {
            accessor: InstanceActivityLogsListField.ACTIVITY_DATE,
            title: 'When',
            sortable: true,
            render: (record: InstanceActivityLogsList) => {
                let activityDate: string | Date | null = record?.[InstanceActivityLogsListField.ACTIVITY_DATE] != null && record?.[InstanceActivityLogsListField.ACTIVITY_DATE] != "" ? DateHelper.getFormattedDate(record?.[InstanceActivityLogsListField.ACTIVITY_DATE], "dd/MM/yyyy hh:mm a") : null;
                
                return <InstanceDetailsContainer $darkMode={isDarkMode}>
                    <span className='alDateText'>{activityDate ?? '--'}</span>
                </InstanceDetailsContainer>
            }
        },
        {
            accessor: InstanceActivityLogsListField.ACTOR,
            sortable: true,
        },

        {
            accessor: InstanceActivityLogsListField.MESSAGE,
            title: 'Event',
            sortable: true,
        },
    ];

    //Event Handlers
    useEffect(() => {
        instancesInvalidateQueries();
    }, [instanceId]);
    
    return <ActivityLogsTableContainer>
        <TableContainer elevation={2} $isNotBorderRadiusAll={true}>
            <CustomListComponent
                fetching={(fetchStatus == "fetching" && triggeredQuery == CachingEnum.INSTANCE_ACTIVITY_LOGS_LIST) || (fetchStatus == "fetching" && triggeredQuery == 'all')}
                striped
                columns={tableColumns}
                idAccessor={(record: InstanceActivityLogsList) => `instanceActivityLogs${record?.[InstanceActivityLogsListField.PUBLIC_ID]}`}
                records={data?.data?.list ?? []}
                totalRecords={data?.data?.metaData?.totalCount ?? 0}
                page={queryStr.pageNumber}
                recordsPerPage={queryStr.pageSize}
                defaultColumnSort={{ columnAccessor: queryStr?.sortBy ?? 'id', direction: queryStr?.orderBy ?? 'asc' }}
                onSortStatusChange={((sort: any) => { 
                    if(settriggeredQuery) {
                        settriggeredQuery(CachingEnum.INSTANCE_ACTIVITY_LOGS_LIST);
                    }

                    setQueryStr((prev: any) => ({ ...prev, sortBy: sort?.columnAccessor ?? "id", orderBy: sort?.direction ?? "asc", pageNumber: 1 }));
                })}
                setPage={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageNumber: p }))}
                onRecordsPerPageChange={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageSize: p, pageNumber: 1 }))} />
        </TableContainer>
    </ActivityLogsTableContainer>
}
